import { z } from 'zod';
export const HouseholdMe = z.object({
    id: z.number().int(),
    name: z.string(),
    email: z.string().email(),
    accent_color: z.string().regex(/^#[0-9a-f]{6}$/i),
    gemini_key_set: z.boolean(),
    is_admin: z.boolean(),
    budget_start_day: z.number().int().min(1).max(28),
});
export const UpdateHouseholdRequest = z
    .object({
    name: z.string().min(1).max(120).optional(),
    accent_color: z
        .string()
        .regex(/^#[0-9a-f]{6}$/i)
        .optional(),
    budget_start_day: z.number().int().min(1).max(28).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
export const PutGeminiKeyRequest = z.object({
    key: z.string().max(500),
});
export const PutGeminiKeyResponse = z.object({
    gemini_key_set: z.boolean(),
});
